import React from 'react'
import cl from 'classnames'
import { RowProps } from './Row.props'
import styles from './Row.module.scss'

const RowComponent = (props: RowProps) => {
  const { children, className, style } = props

  return (
    <div className={cl(styles.container, className)} style={style}>
      {children}
    </div>
  )
}

const Row = RowComponent
export { Row }
